import { render, staticRenderFns } from "./create.vue?vue&type=template&id=da5cef6e&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "./create.vue?vue&type=style&index=0&id=da5cef6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5cef6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da5cef6e')) {
      api.createRecord('da5cef6e', component.options)
    } else {
      api.reload('da5cef6e', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=da5cef6e&scoped=true&", function () {
      api.rerender('da5cef6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/create.vue"
export default component.exports